import { Entity } from '@adornis/baseql/decorators.js';
import { KooperationsPartner } from './KooperationsPartner.js';
import { Partner } from './Partner.js';

/**
 * @entity MediaCompany
 */
@Entity()
export class MediaCompany extends Partner {
  static override _class = 'MediaCompany';

  override get type() {
    return KooperationsPartner.MEDIA_COMPANY;
  }
}
